import { Link } from 'react-router-dom';
import Container from '../../components/shared/Container';
import PageHero from '../../components/shared/PageHero';
import styles from './PoliticaDeCookiesPage.module.css';

export default function PoliticaDeCookiesPage() {
  return (
    <>
      <PageHero
        breadcrumb={[{ label: 'Inicio', to: '/' }, { label: 'Política de cookies' }]}
        title="Política de cookies"
        image={null}
      />

      <Container as="section" className={styles.section}>
        <div className={styles.inner}>
          <article className={styles.content}>
            <p>
              Esta política explica qué son las cookies y qué uso hace de ellas el portal www.solimat.com,
              titularidad de SOLIMAT MATEP Seg. Social nº 72.
            </p>

            <div className={styles.highlight}>
              <strong>De momento no utilizamos cookies.</strong> Actualmente esta web no instala cookies de
              analítica, de publicidad ni de perfilado, ni propias ni de terceros. Tampoco recogemos datos de
              navegación con fines estadísticos o comerciales, por lo que no es necesario solicitarte tu
              consentimiento ni mostrarte un panel de configuración de cookies.
            </div>

            <h2>¿Qué son las cookies?</h2>
            <p>
              Las cookies son pequeños archivos que un sitio web puede almacenar en tu dispositivo cuando lo
              visitas. Sirven, entre otras cosas, para recordar tus preferencias, mantener una sesión abierta o
              medir el uso que se hace de la página.
            </p>

            <h2>¿Qué usamos entonces?</h2>
            <p>
              Para que la web funcione correctamente puede ser necesario emplear almacenamiento técnico
              estrictamente necesario en tu navegador (por ejemplo, para mantener la sesión iniciada en el área
              de administración o para recordar ajustes básicos de la navegación). Este tipo de información:
            </p>
            <ul className={styles.list}>
              <li>Es imprescindible para prestar el servicio que has solicitado.</li>
              <li>No se utiliza con finalidades analíticas, publicitarias ni de elaboración de perfiles.</li>
              <li>No se cede a terceros.</li>
              <li>Está exenta del deber de obtener consentimiento previo conforme a la normativa vigente.</li>
            </ul>

            <h2>¿Y si en el futuro cambia?</h2>
            <p>
              Si más adelante incorporamos cookies que no sean estrictamente necesarias, actualizaremos esta
              política y te pediremos tu consentimiento previo mediante un aviso en la propia web, en el que
              podrás aceptarlas, rechazarlas o configurarlas.
            </p>

            <h2>Cómo gestionar las cookies en tu navegador</h2>
            <p>
              En cualquier caso, puedes revisar, bloquear o eliminar las cookies almacenadas en tu equipo desde
              la configuración de privacidad de tu navegador (Chrome, Firefox, Edge, Safari u otros). Ten en
              cuenta que bloquear el almacenamiento técnico necesario puede afectar al funcionamiento de
              algunas partes de la web.
            </p>

            <h2>Más información</h2>
            <p>
              Puedes consultar cómo tratamos tus datos personales en nuestra{' '}
              <Link to="/politica-de-privacidad">Política de privacidad</Link> y las condiciones de uso del
              portal en el <Link to="/aviso-legal">Aviso legal</Link>.
            </p>
          </article>
        </div>
      </Container>
    </>
  );
}
